import { useQuery } from 'react-query';

import Auth from 'src/services/api/auth/Auth';
import { queryKeys } from 'src/services/api/constants';

export const useLoggedInUser = () => {
    return useQuery(
        [queryKeys.loggedInUser],
        async () => Auth.getLoggedInUser(),
        {
            enabled: !!Auth.accessToken,
            /**
             * `retry` is inherited from the shared QueryClient (see
             * src/services/api/provider.tsx): 429 and 5xx are retried with
             * backoff and jitter, 4xx never is. That is exactly what this query
             * wants — a rejected session fails straight through to the redirect
             * Auth has already started, while a blip on the one request every
             * authenticated screen waits on gets another go. The `retry: false`
             * that used to be here also suppressed those 5xx retries.
             */
            refetchOnWindowFocus: false,
        }
    );
};
